// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".checkout-sub-page__button-container{margin:3.5rem 0 0 0}", "",{"version":3,"sources":["webpack://./src/components/Checkout/CheckoutSubPageButtonContainer/CheckoutSubPageButtonContainer.scss"],"names":[],"mappings":"AAEA,qCACI,mBAAA","sourcesContent":["@import '~style';\n\n.checkout-sub-page__button-container {\n    margin: 3.5rem 0 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
